import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { List } from '@fluentui/react';
import SuggestionItem from './SuggestionItem/SuggestionItem.esm.js';
import SuggestionTitle from './SuggestionTitle/SuggestionTitle.esm.js';

var Suggestions = function(param) {
    var children = param.children, searchTerm = param.searchTerm, items = param.items;
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            children,
            /*#__PURE__*/ jsx(List, {
                items: items,
                onRenderCell: function(item, index) {
                    if (!item) {
                        return null;
                    }
                    var isFirstItem = !children && index === 0;
                    return /*#__PURE__*/ jsx(SuggestionItem, {
                        isFirstItem: isFirstItem,
                        item: item,
                        children: /*#__PURE__*/ jsx(SuggestionTitle, {
                            title: item.displayText,
                            searchTerm: searchTerm
                        })
                    });
                }
            })
        ]
    });
};

export { Suggestions as default };
